import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import classnames from 'classnames';
import Feature from 'components/Feature';

export default {
  propTypes: {
    shareable: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      shareable: false,
    };
  },

  contextTypes: {
    router: PropTypes.object,
  },

  linkLocations(kit) {
    const baseUrl = (this.props.shareable) ? `${kit.shareableDocumentationPath}` : `/kits/${kit.token}/docs`;

    return {
      summary: `${baseUrl}`,
      icons: `${baseUrl}/icons`,
      typefaces: `${baseUrl}/typefaces`,
      images: `${baseUrl}/images`,
    };
  },

  renderSummarySub() {
    return (
      <ul className="list-unstyled text-sm">
        <li className="m-xs-b-xs">
          <a href="#get-started-build">Build your Kit</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#get-started-use">How to use your Kit</a>
        </li>
      </ul>
    );
  },

  renderIconsSub() {
    return (
      <ul className="list-unstyled text-sm">
        <li className="m-xs-b-xs">
          <a href="#kit-components-icons-inventory">Icons in this Kit</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#kit-components-icons-use-web">Using your icons on the web</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#kit-components-icons-use-desktop">Using your icons on the desktop</a>
        </li>
        <li className="m-xs-b-0">
          <a href="#kit-components-icons-troubleshooting">Troubleshooting Icons</a>
        </li>
      </ul>
    );
  },

  renderTypefacesSub() {
    return (
      <ul className="list-unstyled text-sm">
        <li className="m-xs-b-xs">
          <a href="#kit-components-typefaces-inventory">Typefaces in this kit</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#kit-components-typefaces-use">Using your typefaces on the web</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#kit-components-typefaces-troubleshooting">Troubleshooting Typefaces</a>
        </li>
      </ul>
    );
  },

  renderImagesSub() {
    return (
      <ul className="list-unstyled text-sm">
        <li className="m-xs-b-xs">
          <a href="#kit-components-images-inventory">Images in this kit</a>
        </li>
        <li className="m-xs-b-xs">
          <a href="#kit-components-images-troubleshooting">Troubleshooting images</a>
        </li>
      </ul>
    );
  },

  renderNavigation(kit, someOptions = {}) {
    const options = Object.assign({},
      {
        hasBeenPublished: false,
      },
      someOptions,
    );
    const {hasBeenPublished} = options;
    const {router} = this.context;
    const linkLocations = this.linkLocations(kit);
    const {summary, icons, typefaces, images} = linkLocations;
    const iconsActive = router.isActive(icons);
    const typefacesActive = router.isActive(typefaces);
    const imagesActive = router.isActive(images);
    const summaryActive = router.isActive(summary) && !iconsActive && !typefacesActive && !imagesActive;

    const linkClasses = classnames(
      'block',
      'link-dashed-none',
      {'is-disabled': !hasBeenPublished},
      {'text-gray-lighter': !hasBeenPublished}
    );

    return (
      <div className="kit-components-nav">
        <Link to={summary} className="block link-dashed-none m-xs-b-sm">
          <h3 className={classnames('text-lg m-xs-b-xs', {'text-gray': summaryActive})}>Getting Started</h3>
          <p className="text-sm text-muted m-xs-b-0">How to start using your kit.</p>
        </Link>
        {(summaryActive) ? this.renderSummarySub() : ''}
        <hr />
        <Link to={icons} className={linkClasses}>
          <h3 className={classnames('text-lg m-xs-b-xs', {'text-gray': iconsActive})}>Icons</h3>
          <p className="text-sm text-muted m-xs-b-0">Use your kit&apos;s icons in your project's code and on the desktop.</p>
        </Link>
        {(iconsActive) ? this.renderIconsSub() : ''}
        <hr />
        <Link to={typefaces} className={linkClasses}>
          <h3 className={classnames('text-lg m-xs-b-xs', {'text-gray': typefacesActive})}>Typefaces</h3>
          <p className="text-sm text-muted m-xs-b-0">Use your kit&apos;s typefaces in your project's code.</p>
        </Link>
        {(typefacesActive) ? this.renderTypefacesSub() : ''}
        <Feature name="images">
          <hr />
          <Link to={images} className={linkClasses}>
            <h3 className={classnames('text-lg m-xs-b-xs', {'text-gray': imagesActive})}>Images</h3>
            <p className="text-sm text-muted m-xs-b-0">Store and use all of your photos, graphics, and visual assets</p>
          </Link>
          {(imagesActive) ? this.renderImagesSub() : ''}
        </Feature>
      </div>
    );
  },
};



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/mixins/DocumentationMixin.js